module.exports = __webpack_public_path__ + "img/full5-min.fe2621fb.png";